import { ApplicationPaneHeader } from '../../atoms/applications/ApplicationPaneHeader';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './applicationPageUserInfoPane.module.scss';
import { Page, Pane, PaneBody } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { UserForm } from '../../molecules/applications/UserForm';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';

type Props = {
    applicationState: BaseApplicationPageState;
    nextButtonLabel?: string;
};

@inject('applicationState')
@observer
export class ApplicationPageUserSummaryPane extends React.Component<Props> {
    render() {
        const {
            applicationState: {
                applicationPageResource,
                name,
                userFormState,
                validateUserAndNext,
                submitState: { submitting },
            },
            nextButtonLabel,
        } = this.props;
        if (applicationPageResource.loading) {
            return <Loader />;
        }
        return (
            <Page>
                <Pane styleName="pane">
                    <PaneBody>
                        <ApplicationPaneHeader plan={name} />
                        <UserForm
                            submitting={submitting}
                            state={userFormState}
                            onSubmit={validateUserAndNext}
                            buttonLabel={nextButtonLabel || 'プラン内容の確認へ'}
                            showPasswordFields={false}
                        />
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
